import { render, staticRenderFns } from "./content-material.vue?vue&type=template&id=0bcc9dba&scoped=true&"
import script from "./content-material.vue?vue&type=script&lang=js&"
export * from "./content-material.vue?vue&type=script&lang=js&"
import style0 from "./content-material.vue?vue&type=style&index=0&id=0bcc9dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc9dba",
  null
  
)

export default component.exports